import { Directive, inject } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { Observable, shareReplay, tap } from 'rxjs';

/**
 * This directive is responsible for providing an observable which triggers when
 * the form is submitted to any implementations of ApxFormControl.
 *
 * It uses a generic [formGroup] attribute selector to apply itself to any FormGroup
 * instances independent of whether they reside on a <form> tag or not.
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '*[formGroup]',
    standalone: true
})
export class ApxFormGroupDirective {
    formGroupDirective = inject(FormGroupDirective, { self: true, optional: true });

    submit$!: Observable<SubmitEvent>;

    constructor() {
        if (this.formGroupDirective) {
            const formGroupDirective = this.formGroupDirective;
            this.submit$ = formGroupDirective.ngSubmit.asObservable().pipe(
                tap(() => {
                    formGroupDirective.form.markAllAsTouched();
                }),
                shareReplay()
            );
        }
    }
}
